import React, { useMemo } from "react";
import { useGetApiQuery } from "../redux/services/apiHome";
import Loader from "../components/Loader";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { extractDateFromStr, getLatestUpdatedObject } from "../Utils/utils";
import PageLastUpdated from "../components/shared/PageLastUpdated";

const VideoGalleryDetailPage = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: videosGalleryData = [], isLoading: videosGalleryIsLoading } =
    useGetApiQuery({ url: "video-gallery", lang: languageType });

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(
      getLatestUpdatedObject(videosGalleryData)?.changed
    );
  }, [videosGalleryData]);

  if (videosGalleryIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Video Gallery", "वीडियो गैलरी")}
        titleLink="/video-gallery-detail"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Video Gallery", "वीडियो गैलरी")}
      />

      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

              {videosGalleryData?.length === 0 ? (
                <div className="container">
                  <div className="">
                    <h4 className="title4">No Video Found</h4>
                  </div>
                </div>
              ) : (
                <div className="row mb-5">
                  {videosGalleryData.map((item, index) => (
                    <div
                      className="col-12 col-sm-12 col-md-3 col-lg-3 mvDescWrap mb-3"
                      key={index}
                    >
                      <div className="photo-gallery-area desc-sec photo-gallery-detail-page video-wrapper video-card ">
                        <div className="card-sec">
                          <div className="img-sec">
                            <video
                              width="100%"
                              height="auto"
                              controls={true}
                              // autoPlay={true}
                              loop={true}
                              muted={true}
                            >
                              <source
                                src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-08/${item.field_video}`}
                                type="video/mp4"
                              />
                            </video>
                          </div>
                          {/* <div className="desc-sec">
                            <p>{item.title.slice(0, 70)}</p>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default VideoGalleryDetailPage;
